<template>
  <CSidebar 
    :minimize="minimize"
    unfoldable
    :show.sync="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img src="img/tbfi-logo.svg" class="c-sidebar-brand-full" width=150 height=46/>
    </CSidebarBrand>
    <!-- <CSidebarHeader/> -->
    <!-- <CSidebarForm/> -->
    <CSidebarForm>
      <CRow class="mt-3 ml-1 mr-1">
        <CCol sm="3">Entité</CCol>
        <CCol>
          <CSelect size="sm" :value="selected_entity" @update:value="update_entity($event)" :options="entity_options" />
        </CCol>
      </CRow>
      <CRow class="ml-1 mr-1">
        <CCol sm="3">Date</CCol>
        <CCol sm="4">
          <CSelect size="sm" :value="selected_month" @update:value="update_month($event)" :options="month_options" />
        </CCol>
        /
        <CCol >
          <CSelect size="sm" :value="selected_year" @update:value="update_year($event)" :options="year_options" />
        </CCol>
      </CRow>
      <CRow class="ml-1 mr-1 mb-2 mt-n2">
        <CCol>
        <small>Valeurs au {{ (new Date(selected_year, selected_month, 0)).toLocaleDateString('fr-CH') }}<br><br></small>
        </CCol>
      </CRow>
    </CSidebarForm>
    <CRenderFunction flat :contentToRender="nav"/>
    <!-- <CSidebarFooter/> -->
    <CRow class="ml-1 mr-1 mb-2 mt-n2">
      <CCol >
      <small>Dernier calcul:   {{ last_compute_date }}</small>
      <small><br>Dernière importation: {{ last_import_date }}</small>
      </CCol>
    </CRow>
  </CSidebar>
</template>

<script>
import nav from './_nav'
import errorRoutingMixin from '../mixins/errorRoutingMixin'
import axios from 'axios'

export default {
  name: 'TheSidebar',
  mixins: [errorRoutingMixin],
  props: ['reference_month', 'reference_year', 'reference_entity'],
  data () {
    return {
      nav,
      entity_options: [],
      year_options: [],
      month_options: [1,2,3,4,5,6,7,8,9,10,11,12],
      selected_entity: "",
      selected_year: 2026,
      selected_month: 1,
      last_compute_date: "",
      last_import_date: "",
    }
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  },
  created () {
    this.axios_get('webapi/entities').then(data => this.load_entities(data))
    this.axios_get('webapi/years').then(data => this.load_years(data))
    this.axios_get('webapi/freshness-dates').then(data => this.load_update_dates(data))
  },
  methods: {
    axios_get(url) {
        return axios.get(url, {headers: {'Authorization': 'Bearer ' + this.$cookies.get('jwt_access')}})
               .then(response => { return response.data})
               .catch(error => this.$router.push(this.routeOnError(error.response.status)))
    },
    load_entities(entity_options) {
      this.entity_options = entity_options
      this.update_entity(entity_options[0])
    },
    load_years(year_options) {
      this.year_options = year_options
      this.update_year(year_options[0])
    },
    load_update_dates(data) {
      this.last_compute_date = data['last_compute_date']
      this.last_import_date = data['last_import_date']
    },
    update_entity (new_value) {
      this.selected_entity = new_value
      this.$emit('update:reference_entity', new_value)
    },
    update_month (new_value) {
      this.selected_month = new_value
      this.$emit('update:reference_month', new_value)
    },
    update_year (new_value) {
      this.selected_year = new_value
      var current_month = new Date().getMonth() + 1
      var current_year = new Date().getFullYear()
      if (this.selected_year == current_year) {
        var previous_month = (current_month == 1) ? 1 : current_month - 1
        this.update_month(previous_month)
      } else {
        this.update_month(12)
      }
      this.$emit('update:reference_year', new_value)
    }
  }
}
</script>
